module.exports = __webpack_public_path__ + "img/bus2.c52efe95.png";